import { render } from "./NomineeAuth.vue?vue&type=template&id=2c33c1f0"
import script from "./NomineeAuth.vue?vue&type=script&lang=js"
export * from "./NomineeAuth.vue?vue&type=script&lang=js"

import exportComponent from "/home/burton/workspace_skttu/skttu-vote-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__